var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('line-chart',{attrs:{"title":_vm.title,"series":_vm.chartSeries,"xAxis":_vm.xAxisOptions,"yAxis":_vm.yAxisOptions,"colors":['#4CAF50', '#2196F3'],"legend":true,"loading":_vm.loading,"height":"300"}})}
var staticRenderFns = []

export { render, staticRenderFns }